/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
	InternsForEmployerDTO,
	InternsForEmployerDTOFromJSON,
	InternsForEmployerDTOFromJSONTyped,
	InternsForEmployerDTOToJSON,
} from "./InternsForEmployerDTO";

/**
 *
 * @export
 * @interface InternsForEmployerDTOPagedResponse
 */
export interface InternsForEmployerDTOPagedResponse {
	/**
	 *
	 * @type {number}
	 * @memberof InternsForEmployerDTOPagedResponse
	 */
	page?: number;
	/**
	 *
	 * @type {number}
	 * @memberof InternsForEmployerDTOPagedResponse
	 */
	pageSize?: number;
	/**
	 *
	 * @type {number}
	 * @memberof InternsForEmployerDTOPagedResponse
	 */
	totalCount?: number;
	/**
	 *
	 * @type {Array<InternsForEmployerDTO>}
	 * @memberof InternsForEmployerDTOPagedResponse
	 */
	data?: Array<InternsForEmployerDTO> | null;
}

export function InternsForEmployerDTOPagedResponseFromJSON(
	json: any
): InternsForEmployerDTOPagedResponse {
	return InternsForEmployerDTOPagedResponseFromJSONTyped(json, false);
}

export function InternsForEmployerDTOPagedResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): InternsForEmployerDTOPagedResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		page: !exists(json, "page") ? undefined : json["page"],
		pageSize: !exists(json, "pageSize") ? undefined : json["pageSize"],
		totalCount: !exists(json, "totalCount") ? undefined : json["totalCount"],
		data: !exists(json, "data")
			? undefined
			: json["data"] === null
			? null
			: (json["data"] as Array<any>).map(InternsForEmployerDTOFromJSON),
	};
}

export function InternsForEmployerDTOPagedResponseToJSON(
	value?: InternsForEmployerDTOPagedResponse | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		page: value.page,
		pageSize: value.pageSize,
		totalCount: value.totalCount,
		data:
			value.data === undefined
				? undefined
				: value.data === null
				? null
				: (value.data as Array<any>).map(InternsForEmployerDTOToJSON),
	};
}
